import configs from '@/config'

/**
 * PostMessage Events Configuration for AI Chatbot
 * Manages cross-origin messaging with AI Chatbot app
 */

// PostMessage Event Types
export const POST_MESSAGE_EVENTS = {
  AI_IMPORT_REQUEST: 'AI_IMPORT_REQUEST',
}

// AI Chatbot Origins - matches the URL construction in ai-chatbot.module.js
export const ALLOWED_ORIGINS = {
  AI_CHATBOT: {
    // Get target origin matching the AI Chatbot URL construction
    getTargetOrigin() {
      if (!configs.aiAppUrl) {
        return null
      }
      try {
        return new URL(configs.aiAppUrl).origin
      } catch {
        // A misconfigured non-absolute value (legacy bare-hostname) would throw; degrade to null.
        return null
      }
    },
    // Get AI Chatbot iframe window reference
    getTargetWindow() {
      const globalChatbotContainer = document.querySelector('.global-chatbot-container')
      if (!globalChatbotContainer) {
        return null
      }

      const iframe = globalChatbotContainer.querySelector('iframe')
      return iframe?.contentWindow || null
    },
  },
}

export default {
  POST_MESSAGE_EVENTS,
  ALLOWED_ORIGINS,
}
